import { MEDIA_BASE_URL } from "../../settings";

/**
 * Follow-on actions below the map, as NSW Design System cards.
 * https://designsystem.nsw.gov.au/components/card/index.html
 *
 * Both destinations were checked to return 200 when this was written.
 *
 * Images are 1200px web copies of the supplied 7437px artwork, which weighed
 * 12 MB and 8.5 MB. The design system crops card images to a 200px-tall
 * strip with `object-fit: cover`; `imageClass` adjusts that per image (see
 * nsw-overrides.css). Both are decorative — the card title names the link —
 * so their alt text is empty.
 */
export const CARDS = [
  {
    title: "Follow us",
    copy: "Follow us on social media to keep up with this year’s World Teachers’ Day celebrations.",
    href: "https://www.instagram.com/nswedustandards/",
    image: "/img/card-follow-us.jpg",
    imageClass: "wtd-card-image--upper",
  },
  {
    title: "Download the celebration kit",
    copy: "Continue the World Teachers’ Day celebrations by downloading the World Teachers’ Day assets to use at school and on social media.",
    href: "https://www.nsw.gov.au/education-and-training/nesa/awards-and-events/world-teachers-day/celebration-kit",
    image: "/img/card-celebration-kit.jpg",
    imageClass: "wtd-card-image--upper",
  },
];

const NswCards = () => (
  <section className="nsw-section" aria-label="More World Teachers’ Day">
    <div className="nsw-container">
      <div className="nsw-grid">
        {CARDS.map(({ title, copy, href, image, imageClass }) => (
          <div className="nsw-col nsw-col-md-6" key={href}>
            <div className="nsw-card">
              <div className={`nsw-card__image ${imageClass}`}>
                <img
                  src={MEDIA_BASE_URL + image}
                  alt=""
                  width="1200"
                  height="1200"
                  loading="lazy"
                />
              </div>
              <div className="nsw-card__content">
                <div className="nsw-card__title">
                  <a href={href}>{title}</a>
                </div>
                <div className="nsw-card__copy">
                  <p>{copy}</p>
                </div>
                <span
                  className="material-icons nsw-material-icons"
                  focusable="false"
                  aria-hidden="true"
                >
                  east
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default NswCards;
